export const DASHBOARD_UNAUTHORIZED_REASON_CODES = {
  COOKIE_MISSING: 'cookie_missing',
  TOKEN_INVALID: 'token_invalid',
  TOKEN_MISSING: 'token_missing',
  TOKEN_REFRESH_FAILED: 'token_refresh_failed',
  USER_NOT_FOUND: 'user_not_found',
  ORG_NOT_FOUND: 'org_not_found',
  MEMBERSHIP_LOOKUP_FAILED: 'membership_lookup_failed',
  MEMBERSHIP_INACTIVE: 'membership_inactive',
  SCOPES_MISSING: 'scopes_missing',
  ACCOUNT_DEACTIVATED: 'account_deactivated',
  UNKNOWN: 'unknown',
} as const;

export type DashboardUnauthorizedReasonCode =
  (typeof DASHBOARD_UNAUTHORIZED_REASON_CODES)[keyof typeof DASHBOARD_UNAUTHORIZED_REASON_CODES];
